var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_3007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4623 12.3086H11.8855L10.8076 17.6992H13.5401L12.4623 12.3086Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.264 23.0898C34.846 24.653 35.62 25.9184 36.4765 26.9951C37.3331 25.9184 38.1969 24.6529 38.7789 23.0898H34.264Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9571 8.17578H25.2207L28.7104 36.1782C28.7721 37.3235 28.459 38.4018 27.7115 39.246L21.8018 46H41.9571C44.1864 46 46 44.1864 46 41.957V12.3086C46 10.0792 44.1864 8.17578 41.9571 8.17578ZM41.9571 23.0898H41.5971C40.8303 25.55 39.6143 27.4751 38.3506 28.9928C39.3405 29.8978 40.3992 30.6403 41.4517 31.4719C42.0321 31.9365 42.1269 32.784 41.6609 33.3657C41.1972 33.9466 40.3463 34.0407 39.7671 33.575C38.6235 32.6723 37.55 31.9167 36.4766 30.9317C35.4031 31.9167 34.4195 32.6723 33.2759 33.575C32.6967 34.0407 31.8459 33.9466 31.3821 33.3657C30.9162 32.784 31.0109 31.9365 31.5913 31.4719C32.6439 30.6403 33.6126 29.8978 34.6026 28.9928C33.3389 27.4752 32.2126 25.5501 31.4459 23.0898H31.086C30.3411 23.0898 29.7383 22.4871 29.7383 21.7422C29.7383 20.9973 30.3411 20.3945 31.086 20.3945H35.1289V19.0469C35.1289 18.302 35.7317 17.6992 36.4766 17.6992C37.2215 17.6992 37.8242 18.302 37.8242 19.0469V20.3945H41.9571C42.702 20.3945 43.3047 20.9973 43.3047 21.7422C43.3047 22.4871 42.702 23.0898 41.9571 23.0898Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9366 3.54155C21.6852 1.52267 19.9599 0 17.9253 0H4.04297C1.81359 0 0 1.81359 0 4.04297V33.8711C0 36.1005 1.81359 37.9141 4.04297 37.9141C12.0993 37.9141 17.8948 37.9141 25.2956 37.9141C25.6888 37.4647 26.0183 37.1833 26.0322 36.5967C26.0356 36.4496 21.9548 3.68746 21.9366 3.54155ZM16.5262 25.7588C15.8116 25.9059 15.0877 25.442 14.9404 24.702L14.0791 20.3945H10.2687L9.40736 24.702C9.26262 25.4311 8.55977 25.9101 7.82153 25.7588C7.09245 25.6127 6.61861 24.9034 6.7647 24.173L9.45992 10.6964C9.58624 10.0674 10.139 9.61328 10.7812 9.61328H13.5664C14.2086 9.61328 14.7614 10.0674 14.8877 10.6964L17.5831 24.173C17.7291 24.9034 17.2554 25.6127 16.5262 25.7588Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7461 40.6094L15.9774 42.4584C16.1315 43.6968 16.9543 44.9595 18.3077 45.59C20.8618 42.7785 19.3166 44.4794 22.8322 40.6094H15.7461Z",
    fill: "#5BA1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_3007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLanguage);
export default __webpack_public_path__ + "static/media/icon-language.d8c6a76b56db2c1162f49e958562b34d.svg";
export { ForwardRef as ReactComponent };